import { useEffect } from 'react';
import { useObserver } from 'mobx-react-lite';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { useDutchiePay } from 'src/payments/hooks';
import useUI from 'hooks/use-ui';
import { initDispensaryGaV4Tracker } from 'utils/analytics/clients/dispensary-ga-v4-client';

import { tracker } from '..';

type ReturnValue = {
  loading: boolean;
};

export const useDispensaryMonitor = (): ReturnValue => {
  const { dispensary, loading } = useDispensary();
  const { isDutchiePayEnabledForDispo } = useDutchiePay();
  const UI = useUI();
  const shouldUseDispensaryGA = useObserver(() => UI.isEmbedded || UI.isStoreFront || UI.isPlus || UI.isKiosk);

  useEffect(() => {
    if (!loading && dispensary) {
      tracker.setContext({ activeDispensary: { isDutchiePayEnabledForDispo, ...dispensary } });

      if (dispensary.googleAnalyticsID && shouldUseDispensaryGA) {
        initDispensaryGaV4Tracker(dispensary.googleAnalyticsID);
      }
    }
  }, [loading, dispensary, isDutchiePayEnabledForDispo, shouldUseDispensaryGA]);
  return { loading };
};
